import type { CSSProperties } from 'react';

import { UnityLogo } from '@/components/shared/unity-logo';
import { cn } from '@/utils/cn';
import { useTheme } from '@/stores/theme-store';

import './gallery.css';

type UnityLogoAnimationProps = {
  className?: string;
};

const SYMBOL_MASK = {
  light: '/brand/symbol-color.png',
  dark: '/brand/symbol-on-dark.png',
} as const;

/**
 * Official Unity symbol with a soft light sweeping its surface. Used on the
 * widget gallery and as a reference for loading / empty-state motion.
 */
export const UnityLogoAnimation = ({ className }: UnityLogoAnimationProps) => {
  const resolved = useTheme((state) => state.resolved);
  const maskSrc = SYMBOL_MASK[resolved];
  const variant = resolved === 'dark' ? 'symbol-on-dark' : 'symbol-color';

  return (
    <div
      className={cn('gallery-unity-logo-animation', className)}
      aria-hidden="true"
      style={{ '--gallery-unity-mask': `url(${maskSrc})` } as CSSProperties}
    >
      <UnityLogo variant={variant} className="gallery-unity-logo-animation__mark" />
      <div className="gallery-unity-logo-animation__surface-glow" />
    </div>
  );
};
